export default class ComboRecentOrFavOrderItem extends React.Component {
    constructor(props) {
        super(props);

    }
   
    componentDidMount(){

    }

    render() {
        return (
            <div>
            <div className="exp-row">
            <div className="item-image mar-right15">
            <img src={this.props.img} className="img-fluid" alt="Family Feast"/>
                </div>
                    <div className="item-description">
                        <p className="item-headline">{this.props.title} {this.props.itemCount > 1 ? ' (' + this.props.itemCount + ')': ''}</p>
                    {/*<p className="item-info">{this.props.calories} Cal</p>*/}
                    <p className="item-details">{this.props.description}</p>
                    </div>
                </div>
                </div>
        );
                    }
}
